import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoRn: CultureInfo = {
  name: 'rn',
  displayName: 'Ikirundi',
  iso3LanguageCode: 'run',
  iso2LanguageCode: 'rn',
  ietfLanguageTag: 'rn',
  parent: null
};
